import { PaymentAPI as n } from "./paymentApi.js";
import { CashbackProcess as r } from "./processes/cashback.process.js";
import { DummyPaymentProcess as a } from "./processes/dummy.process.js";
async function i(o) {
  const e = {
    ...o,
    locale: o.locale ?? "en"
  };
  switch (e.engine) {
    case n.PaymentMethodEngine.REDSYS: {
      const { RedsysPaymentProcess: t } = await import("./processes/redsys.process.js");
      return new t(e);
    }
    case n.PaymentMethodEngine.ADYEN: {
      const { AdyenPaymentProcess: t } = await import("./processes/adyen.process.js");
      return new t(e);
    }
    case n.PaymentMethodEngine.STRIPE: {
      const { StripePaymentProcess: t } = await import("./processes/stripe.process.js");
      return new t(e);
    }
    case n.PaymentMethodEngine.CASHBACK:
      return new r(e);
    case n.PaymentMethodEngine.PAY_LATER:
    case n.PaymentMethodEngine.CASH:
      return new a({
        ...e,
        engine: e.engine
      });
    default:
      throw new Error("Unknown engine");
  }
}
export {
  i as getPaymentProcess
};
//# sourceMappingURL=getPaymentProcess.js.map
